import React from 'react';

const TxtHeaderXL = ({ children }) => {
    return (
        <div className='font-bold text-4xl text-primary-dark-s1l1 dark:text-primary-light-s1l1'>
            {children}
        </div>
    );
};

export default TxtHeaderXL